import { createPortal } from "react-dom";

const PopupPortal = ({ mountNode, children }) => {
    return createPortal(children, mountNode);
};

export default PopupPortal;
